import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ThemeService } from '@services/themes.service';

/**
 * Interruttore del tema.
 *
 * Era un finto interruttore costruito con checkbox e label, largo 72px, dentro
 * un `container` di Bootstrap in cima alla sidebar. Ora e' un bottone icona
 * come gli altri della barra in alto.
 */
@Component({
  selector: 'app-toggle-theme',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './toggle-theme.component.html',
})
export class ToggleThemeComponent {
  readonly tema = inject(ThemeService);
}
